declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const META_PIXEL_ID = '2202174087193139'

let injected = false

/**
 * Injects the Meta Pixel base code once and fires the single PageView.
 * Safe to call multiple times: only the first call does anything.
 */
export const loadMetaPixel = (): void => {
  if (injected || typeof window === 'undefined') return
  injected = true

  if (window.fbq) return

  const script = document.createElement('script')
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];
    t=b.createElement(e);t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}
    (window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${META_PIXEL_ID}');
    fbq('track', 'PageView');
  `
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)
}

/**
 * Fires a standard Meta event, making sure the base code exists first.
 */
export const trackMetaEvent = (event: string): void => {
  if (typeof window === 'undefined') return
  loadMetaPixel()
  if (typeof window.fbq === 'function') {
    window.fbq('track', event)
  }
}
